// --------------------------
// IMPORTS
// --------------------------
import { useEffect, useRef, useState } from "react";

import media from "../../../media";
import { useMsal } from "@azure/msal-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HandleSearch from "../../../utils/CommonSearchComponent";
import { store } from "../../../store";

import moment from "moment";
import NavMarker from "../../../components/atoms/NavMarker";
import { VscChevronDown } from "react-icons/vsc";
import { FaBell } from "react-icons/fa";
import useCurrentPath, { decryptData } from "../../../utils/Constants";
import { getLimitedNotificationListThunk } from "../../../store/thunks/dashboardThunk";

import { signoutThunk } from "../../../store/thunks/authThunk";
import NotificationPanel from "../../../components/molecules/NotificationPanel/Notification";
import { Modal } from "antd";
import AddForm from "../../../components/molecules/Forms/addForm";
import DelegateAccess from "../../DelegateAccess";

// --------------------------
// MAIN COMPONENT
// --------------------------
export default function TopHeader() {
  //Dispatch + Custom Hooks
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = useCurrentPath();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  
  // --------------------------
  // REDUX STATE
  // --------------------------
    let storeRole = useSelector((state) => state.auth.role);
  let storeToken = useSelector((state) => state.auth.accessToken);
  let storeLIUId = useSelector((state) => state.auth.lIUId);
  let storeUserInfo = useSelector((state) => state.auth.userInfo);
  storeUserInfo = decryptData(storeUserInfo);
  const storeProfileImage = storeUserInfo?.user?.profilePicUrl;
  const storeCanDelegateAccess = storeUserInfo?.user?.canDelegateAccess;
  const ncount = useSelector((state) => {
    return state.auth.ncount;
  });
  let isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn
  );

  // --------------------------
  // LOCAL STATES
  // --------------------------
  //Logout Button
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isDelegateModalOpen, setIsDelegateModalOpen] = useState(false);  
  const [showLoader, setShowLoader] = useState(true);
  const [list, setList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE,
  });
  
  const getNotificationList = () => {
    const payload = {
      lIUId: storeLIUId,
      role: storeRole,
      page: 1,
      pageSize: 5,
      filterValues: "unread",
    };
    dispatch(getLimitedNotificationListThunk(payload))
      .unwrap()
      .then((response) => {
        const temp =
          response &&
          response?.response.map((records, index) => {
            if (records?.isRead === "0") {
              return {
                id: records._id,
                title: records.title,
                excerpt: records.excerpt,
                assignedBy: records.assignedBy,
                assignedTo: records.assignedTo && records.assignedTo,
                message: records?.message,
                type: records?.type,
                isRead: records?.isRead === "0" ? "Un-read" : "Read",
                createdAt: records.createdAt
                  ? moment
                      .utc(records.createdAt)
                      .local()
                      .format("DD-MM-YY hh:mm A")
                  : "",
              };
            }
          });
        setStoreList(temp || []);
      });
  };
  
  // --------------------------
  // USE EFFECTS
  // --------------------------
  useEffect(() => {
    if (isLoggedIn) {
      // Run the function immediately
      if (storeRole !== process.env.REACT_APP_EROLE) {
        getNotificationList();
      }
      const intervalId = setInterval(() => {
        if (storeRole !== process.env.REACT_APP_EROLE) {
          getNotificationList();
        }
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [storeRole, storeToken, isLoggedIn]);

  //Logout Button
  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [dropdownOpen]);

  // --------------------------
  // HANDLERS
  // --------------------------
  const handleDropdownClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  const openDelegateModal = () => {
    setIsDelegateModalOpen(true);
  };

  const closeDelegateModal = () => {
    setIsDelegateModalOpen(false);
  };
  
  const handleSearch = async (e) => {
    const searchIn = location.pathname.replace("/", "");

    const callActionFrom = "searchBar";

    const allStates = {
      showLoader: showLoader,
      setShowLoader: setShowLoader,
      pagination: pagination
        ? pagination
        : {
            current: 1,
            page: 1,
            pageSize: process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE,
          },
      setPagination: setPagination,
      list: list,
      setList: setList,
    };

    const response = await HandleSearch(
      storeRole,
      storeToken,
      storeLIUId,
      storeAccessTokenExpiresOn,
      searchIn,
      callActionFrom,
      allStates,
      ""
    );
    if (response) {
      // Update local state after fetching data
      const decryptedData = store.getState().auth.list[currentPath + "_info"];

      setStoreList(decryptedData);
      setShowLoader(false);
    }
  };

  const navigateSignIn = () => {
    navigate("/", { replace: true });
  };

  const handleSignOut1 = async () => {
    try {
      dispatch(
        signoutThunk({
          role: storeRole,
          lIUId: storeLIUId,
          token: storeToken,
          accessTokenExpiresOn: storeAccessTokenExpiresOn,
        })
      );
      // Clear the Redux state using the dispatch function.
      //dispatch(clearRedux());
      // Navigate the user to the sign-in page after logout.
      //navigateSignIn();
    } catch (error) {}
  };

  const handleSignOut = async () => {
    try {
      const resultAction = await dispatch(
        signoutThunk({
          role: storeRole,
          lIUId: storeLIUId,
          token: storeToken,
          accessTokenExpiresOn: storeAccessTokenExpiresOn,
        })
      );

      // Optional: check if the thunk was fulfilled or rejected
      if (signoutThunk.fulfilled.match(resultAction)) {
        console.log("Sign out successful");
      } else {
        console.error("Sign out failed", resultAction.payload);
      }
    } catch (error) {
      console.error("Error during sign out:", error);
    }
  };

  const toggleMenu = () => {
    const aside = document.querySelector(".aside");
    if (aside) {
      aside.classList.toggle("open");
    }
  };

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <>
      <div id="kt_header" className="header header-fixed border-bottom">
        <div className="container-fluid d-flex align-items-center justify-content-between">
          <NavMarker
            route={location.pathname && location.pathname.replace("/", "")}
          />
          <div className="topbar">
            <div className="topbar-col">
              <img
                className="hamburg-icon-start"
                src={media.hamburg.svg}
                alt="menu toggle"
                id="hamburgMobile"
                onClick={toggleMenu}
              />
              <img
                className="hamburg-icon-cross"
                src={media.cross.svg}
                alt="menu toggle"
                id="hamburgMobile"
                onClick={toggleMenu}
              />
            </div>
            <div className="topbar-col">
              <div className="topbar-item header-notification">
                <div
                  className="btn btn-icon btn-clean btn-lg mr-1 position-relative"
                  id="kt_quick_panel_toggle"
                  onClick={() => {
                    document
                      .getElementById("kt_quick_panel")
                      .classList.add("offcanvas-on");
                    document
                      .querySelector("body")
                      .classList.add("overflow-hidden");
                  }}
                >
                  {ncount !== 0 && ncount != null && (
                    <span className="label label-danger ml-2 position-absolute"></span>
                  )}

                  <span className="svg-icon svg-icon-xl svg-icon-primary">
                    <FaBell />
                  </span>
                </div>
              </div>

              <NotificationPanel storeList={storeList} nCount={ncount} />
              <div className="dropdow cursor-pointer" ref={dropdownRef}>
                <div className="topbar-item" onClick={handleDropdownClick}>
                  <div className="symbol symbol-30 symbol-circle user-profile-dropdown">
                    <img
                      alt="Pic"
                      className="w-100px"
                      src={
                        storeProfileImage
                          ? process.env.REACT_APP_BACKEND +
                            "/images/" +
                            storeProfileImage
                          : media.user.png
                      }
                    />{" "}
                    <VscChevronDown />
                  </div>
                </div>

                <div
                  className={`borders dropdown-menu p-0 m-0 ${
                    dropdownOpen ? "login-active" : ""
                  }`}
                >
                  <ul className="p-0 mb-0 list-unstyled">
                    {storeCanDelegateAccess===true && (
                      <li
                        className="menu-item p-2 px-5"
                        aria-haspopup="true"
                        onClick={openDelegateModal}
                      >
                        <span className="cursor-pointer font-size-lg font-weight-bolder">
                          Delegate Access
                        </span>
                      </li>
                    )}
                    <li
                      className="menu-item p-2 px-5"
                      aria-haspopup="true"
                      onClick={handleSignOut}
                    >
                      <span className="cursor-pointer font-size-lg font-weight-bolder">
                        Logout
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DelegateAccess
        isDelegateModalOpen={isDelegateModalOpen}
        setIsDelegateModalOpen={setIsDelegateModalOpen}
      />
    </>
  );
}
